/**
 * Created by fenghuan on 2021/1/15.
 */
import axios from 'axios';
export default {
  namespaced: true,
  state: {
    config: {},
  },
  getters: {
    config(state) {
      return state.config;
    },
  },
  mutations: {
    setConfig(state, config) {
      sessionStorage.setItem('flowerConfig', JSON.stringify(config));
      state.config = config;
      return state;
    },
  },
  actions: {
    fetchConfig({ state, commit }) {
        return new Promise((resolve, reject) => {
        if (Object.keys(state.config).length>0) {
          resolve(state.config);
        } else {
          if(location.href.includes('local') || location.href.includes('8080')){
            const config = require('../../pages/flowerroad/utils/flowerRoadConfig.json')
            commit('setConfig', config);
            resolve(config);
          }else{
            axios.get(`https://oss.roewe.com.cn/saicmall/activity/flowerRoad/flowerRoadConfig.json?timestamp=${new Date().getTime()}`).then(res=>{
              const data = res.data;
              console.log('config::',data)
              let jsonData
              if(typeof data == 'object'){
                jsonData = data
              }else{
                jsonData = JSON.parse(data)
              }
              commit('setConfig', jsonData);
              resolve(data);
            }).catch((e) => reject(e))
          }

        }
      });
    },
  },
};
